<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11nhEvp/tc-custom/9781636411569.jpg?1686689497601" alt="This image is the cover for the book Fire Prayers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fire Prayers
      </h1>
      <p class="bookDescription body article font2">
        <b>If there's one spiritual weapon Satan doesn't want you to use, it's <i>prayer.</i></b><br/> <br/>This book will show you the importance of fighting the enemy in the spirit, and why being equipped with God’s warfare weapons is one of the most life-changing experiences of all.<br/> <br/>Christians have an enemy who will do everything in his power to alter, edit, stop, delay, and abort their God-given destiny. Satan and his demonic kingdom have one purpose: to kill, steal, and destroy.<br/> <br/>The enemy does not want our God-ordained prophetic destiny to be fulfilled in this very hour. This is why we need to pray like never before and arm ourselves with the arsenal of heaven like the ambassadors and soldiers of the Lord we are. <i>Fire Prayers</i> will equip you to pick up your weapons of warfare and fight the good fight of faith.<br/> <br/>Filled with powerful teachings, <i>Fire Prayers</i> will equip you with a spiritual warfare arsenal that will leave Satan and his kingdom trembling and unable to manipulate, control, or dominate you; hinder your relationship with Jesus; or thwart your destiny.<br/> <br/><b>FEATURES AND BENEFITS</b><br/>Readers will learn:Prayer is the key for blocking the enemy’s attacksWhy it is so important to fight the kingdom of darknessHow they can live a life free of spiritual chains
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Ramirez
      </h2>
      
      <p class="authorDescription body article"><B>Evangelist John Ramirez</B> used to fight on the enemy&rsquo;s side, so he understands from an insider&rsquo;s point of view how the enemy works. He now fights for Jesus Christ and uses the experience and knowledge he has to teach believers how to fight and gain victory. He is an internationally known evangelist, author, and highly sought-after speaker who teaches believers around the globe how to defeat the enemy. He has shared his powerful testimony of being miraculously saved from a high-ranking satanic priest on <I>It&rsquo;s Supernatural!</I>, <I>The 700 Club</I>, TBN, Daystar, and more.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Charisma Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f9c22e7